// extracted by mini-css-extract-plugin
export default {"confirm_header":"confirmPopup_confirm_header__ye76L","popup_title":"confirmPopup_popup_title__pWDFz","confirm_buttons":"confirmPopup_confirm_buttons__jWfIY"};